export default __webpack_public_path__ + "static/char-s-52-ko-73845be2a79090d8c9a4477813165df4.webp";